import { MSG_ERRO_SERVIDOR } from '../../shared/constantes/mensagens';


const INITIAL_STATE = {
    esperandoSolicitacao: false,
    error: false,
    mensagem: '',
    beneficio:{}    

};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case 'DECLARACAO_DOSSIE_IMPRESSAO_SOLICITADA':            
            return { ...state, esperandoSolicitacao: true, mensagem: '', error: false };

        case 'DECLARACAO_DOSSIE_IMPRESSAO_RECEBIDA':
            return { ...state, esperandoSolicitacao: false, mensagem: 'sucesso', error: false };

        case 'DECLARACAO_DOSSIE_ERRO_IMPRESSAO_RECEBIDO':
            return { ...state, esperandoSolicitacao: false, mensagem: (action.payload) ? action.payload : MSG_ERRO_SERVIDOR, error: true };

        case 'DECLARACAO_DOSSIE_LIMPAR_MENSAGEM':
            return { ...state, error: false, mensagem: '' };

        case 'DECLARACAO_DOSSIE_NAO_ENCONTRADA':
            return { ...state, esperandoSolicitacao: false, mensagem: 'not_found', error: false }

        case 'DECLARACAO_DOSSIE_NOVA_SOCLICITACAO':
            return { ...state, esperandoSolicitacao: false, error: false, mensagem: '' }

        case 'DECLARACAO_DOSSIE_INFO_BENEFICIO':
            return { ...state, esperandoSolicitacao: true, error: false, mensagem: ''};

        case 'DECLARACAO_DOSSIE_ADD_INFORMACOES':
            return { ...state, esperandoSolicitacao: false,beneficio:action.payload.beneficio, error: false, mensagem: 'addInfo'}

        default:
            return state;
    }
}
